<template>
  <div>
        
    <div class="panel panel-default" :style="{borderTop: `4px solid ${colorIcon} !important`}">

        <div v-if="title" class="panel-heading">
          <i style="color: #6d6d6d; margin-right: 5px;" :class="titleIcon"></i>
          {{ title }}
        </div>
        <div class="panel-body">
            <slot></slot>
        </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'input-image',
  props: {

    subTitulo: {
      required: false,
        type: [String],
        default: ''
    },
    colorIcon: {
      required: false,
        type: [String],
        default: '#427896'
    },
    titleIcon: {
       required: false,
        type: [String],
        default: ''
    },

    title: {
        required: false,
        type: [String],
        default: ''
    },

  },
  data () {
    return {
      txt: ''
    }
  },
  methods: {
    onRemove(file, fileList) {
        
        this.image = null;
        this.$emit('input', '');
    },
    clickButton(){

      this.$emit('clickButton');
    }

  },
}
</script>
